import React, { useEffect } from 'react'
import './LogoPartner.scss'

// import logoCircleEnergy from '../../assets/Pictures/LogoPartner_CircleEnergy.svg'
import logoEnergyandinvestment from '../../assets/Pictures/LogoPartner_Energyandinvestment.svg'
import logoKavir from '../../assets/Pictures/LogoPartner_Kavir.svg'

import 'aos/dist/aos.css'
import Aos from 'aos'

export default function LogoPartner() {
  useEffect(() => {
    Aos.init({ duration: 1000, once: true })
  }, [])

  return (
    <div className='logoPartner' data-aos='zoom-in'>
      <div className='container'>
        <div className='row'>
          <img src={logoKavir} alt="logoCircleEnergy" />
          <img style={{ maxWidth: '257px' }} src={logoEnergyandinvestment} alt="logoCircleEnergy" />
          {/* <img src={logoCircleEnergy} alt="logoCircleEnergy" /> */}
        </div>
      </div>
    </div>
  )
}
